// extracted by mini-css-extract-plugin
export var card = "_n9-0";
export var content = "_n9-2";
export var details = "_n9-3";
export var icon = "_n9-1";
export var iconBlue = "_n9-5";
export var iconBrand = "_n9-4";
export var iconGrayBlue = "_n9-6";
export var iconGreen = "_n9-7";
export var iconIndigo = "_n9-8";
export var iconOrange = "_n9-9";
export var iconPurple = "_n9-a";
export var iconRed = "_n9-b";
export var iconWarning = "_n9-c";